// frontend/src/pages/AdminEvents.js
import React, { useState } from 'react';
import EventManagement from '../components/EventManagement';
import TutorialModal from '../components/TutorialModal';
import { hasSeenTutorial } from '../utils/tutorialData';

const AdminEvents = () => {
  const [showTutorial, setShowTutorial] = useState(!hasSeenTutorial('admin-events'));

  return (
    <div className="container mx-auto p-4">
      {showTutorial && (
        <TutorialModal pageId="admin-events" onClose={() => setShowTutorial(false)} />
      )}
      <h1 className="text-display-small font-bold text-on-surface mb-6">Event Verwaltung</h1>
      <EventManagement />
    </div>
  );
};

export default AdminEvents;
